import Login from './Login.vue'
export default {
    path:'login', component: Login
}